module.exports = __webpack_public_path__ + "img/centered-menu-icon.2cef17b9.svg";